// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/** List of all supported framework codes — used for validation. */
export const ROPA_COMPLETENESS_FRAMEWORKS = [
    'PDPL',
    'GDPR',
    'DECREE_165',
    'ISO_27701',
];
/**
 * Sprint 46.0.1 — map the registry's short codes to the canonical
 * `framework_code` values stored in `grc_regulatory_frameworks`. Used by the
 * installed-frameworks filter so the picker only surfaces frameworks the
 * tenant has actually installed via the localization pack-install-engine.
 *
 * ISO 27701 is intentionally absent — it is not a regulatory pack. See
 * `ALWAYS_AVAILABLE_FRAMEWORKS` below.
 */
export const FRAMEWORK_CODE_MAP = {
    PDPL: 'VN_PDPL',
    GDPR: 'EU_GDPR',
    DECREE_165: 'VN_DATA_LAW_DECREE_165_2025',
};
/**
 * Frameworks that are always available in the picker regardless of which
 * regulatory packs the tenant has installed.
 *
 * Sprint 45.4.0 hotfix-3 — ISO 27701 was previously force-listed here
 * even though demo tenants (Saigon Retail Ltd) never installed it,
 * which surfaced an unintended option in the framework picker. The
 * picker is now strictly install-gated: ISO 27701 only appears for
 * tenants that have explicitly opted in via their localization pack.
 */
export const ALWAYS_AVAILABLE_FRAMEWORKS = [];
//# sourceMappingURL=ropa-completeness.js.map